import type { CreateOrganizationResponse } from '../types';
import { OrganizationWizardModal } from './OrganizationWizardModal';

export function CreateOrganizationWizardModal(props: {
  onClose: () => void;
  onCreated: (response: CreateOrganizationResponse) => void;
}) {
  return <OrganizationWizardModal mode="create" {...props} />;
}
